// http.js 或者 axiosService.js
import axios from "axios";

// 创建axios实例
const service = axios.create({
  baseURL: "https://localhost:44372", // 固定的基础URL
  timeout: 5000, // 请求超时时间
});

// 设置默认请求头
service.interceptors.request.use(
  (config) => {
    // 在请求发出前做一些事情
    return config;
  },
  (error) => {
    console.log(error);

    // 处理请求错误
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    return response;
  },
  (error) => {
    // 根据错误码做不同的处理
    console.log(error); // 打印错误信息
    return Promise.reject(error);
  }
);

export default service;
